export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/allin-803da9dc7d8c725d4919b689950c0665.mp3";